export function isPlayRateLimitEnabled() {
    // Disabled by default; set VUE_APP_RATE_LIMIT_ENABLED=1 at build time to enable.
    return String(process.env.VUE_APP_RATE_LIMIT_ENABLED || '') === '1';
}

export async function consumePlayQuota({ access = null } = {}) {
    if (!isPlayRateLimitEnabled()) {
        return { ok: true, status: 200, data: { allowed: true, disabled: true } };
    }

    const qs = new URLSearchParams();
    if (access) qs.set('access', String(access));

    const url = qs.toString() ? `/api/play?${qs.toString()}` : '/api/play';

    try {
        const res = await fetch(url, { method: 'POST' });
        let data = null;
        try {
            data = await res.json();
        } catch {
            data = null;
        }
        return { ok: res.ok, status: res.status, data };
    } catch (e) {
        return { ok: true, status: 0, data: null }; // fail open client-side too
    }
}
